import { FC } from 'react';
import classNames from 'classnames';
import { SvgIconComponent } from '../types/svgs';

const SectionLabel: FC<{
  title: string;
  className?: string;
  containerClassName?: string;
  IconComponent?: SvgIconComponent;
  iconClassName?: string;
}> = ({
  title,
  className,
  containerClassName,
  IconComponent,
  iconClassName,
}) => {
  return (
    <div
      className={classNames(
        'mb-4 flex flex-row items-center justify-start text-secondary-150',
        containerClassName,
      )}
    >
      {IconComponent && (
        <IconComponent
          className={classNames('mr-2 mb-[1px] h-5 w-5', iconClassName)}
        />
      )}
      <div className={classNames('text-body font-medium', className)}>
        {title}
      </div>
    </div>
  );
};

export default SectionLabel;
